module.exports = function () {
  return new Worker(__webpack_public_path__ + "eb5c62f508d6d7da39d2.worker.js");
};